export default "__VITE_ASSET__C9RlnKU5__"